import { productMasterApi } from "./api";

export default async function fetchProductData({
  accessToken,
  mainCountry,
  paginationModel,
  search,
  selectedBrand,
  selectedOwner,
  userFilter,
  selectedCategoryPath,
  selectedKam,
  // showInactive,
}) {
  const buildParams = (field, value) => {
    const params = new URLSearchParams();
    if (userFilter) params.append("owner", userFilter);
    if (selectedOwner && userFilter === null)
      params.append("owner", selectedOwner);
    if (mainCountry?.id) params.append("countryId", mainCountry.id);
    if (search) params.append("sku", search);
    if (selectedBrand) params.append("brand", selectedBrand);
    if (selectedCategoryPath)
      params.append("categoryPath", selectedCategoryPath);
    // if (showInactive) params.append('status', showInactive);
    if (selectedKam) params.append("kam", selectedKam);
    if (paginationModel) {
      params.append("limit", paginationModel.pageSize);
      params.append("offset", paginationModel.page);
    }
    return params;
  };

  const params = buildParams(null, null);
  const res = await productMasterApi.get(
    `GetProductsDisabled?${params.toString()}`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        accept: "*/*",
      },
    },
  );
  return res?.data || [];
}
